import React from "react";

const LeafDecoration = () => {
  return (
    <>
      {/* Top Right Leaves */}
      <div className="fixed top-0 right-0 z-0 opacity-40 pointer-events-none">
        <svg
          width="300"
          height="300"
          viewBox="0 0 300 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M250 50C240 60 230 70 220 80C215 85 210 90 210 95C210 100 215 105 220 105C230 105 245 95 255 85C265 75 275 65 280 55C285 45 280 40 275 40C270 40 260 45 250 50Z"
            stroke="#C9B89A"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M270 70C265 80 260 90 255 100C252 105 250 110 250 115C250 120 253 125 258 125C265 125 275 118 282 110C288 102 293 92 295 82C297 72 293 67 288 67C283 67 277 70 270 70Z"
            stroke="#C9B89A"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M285 90C283 98 280 106 277 114C275 119 274 124 275 129C276 134 280 138 285 137C292 136 299 130 304 123C308 116 311 107 312 98C313 89 310 84 305 84C300 84 292 87 285 90Z"
            stroke="#C9B89A"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>
      </div>

      {/* Bottom Left Leaves */}
      <div className="fixed bottom-0 left-0 z-0 opacity-40 pointer-events-none">
        <svg
          width="300"
          height="300"
          viewBox="0 0 300 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M50 250C60 240 70 230 80 220C85 215 90 210 95 210C100 210 105 215 105 220C105 230 95 245 85 255C75 265 65 275 55 280C45 285 40 280 40 275C40 270 45 260 50 250Z"
            stroke="#C9B89A"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M30 230C38 225 46 220 54 215C59 212 64 210 69 211C74 212 78 216 77 221C76 228 70 235 63 240C56 244 47 247 38 248C29 249 24 245 24 240C24 235 27 232 30 230Z"
            stroke="#C9B89A"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M70 270C75 265 80 260 85 255C88 252 91 250 95 251C99 252 102 256 101 261C100 268 95 275 89 280C83 284 75 287 67 287C59 287 55 283 56 278C57 273 63 273 70 270Z"
            stroke="#C9B89A"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>
      </div>

      {/* Top Left Small Accent */}
      <div className="fixed top-20 left-10 z-0 opacity-30 pointer-events-none hidden lg:block">
        <svg
          width="150"
          height="150"
          viewBox="0 0 150 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M50 30C55 40 60 50 65 60"
            stroke="#C9B89A"
            strokeWidth="1"
            fill="none"
          />
          <path
            d="M65 60C70 55 75 50 80 45"
            stroke="#C9B89A"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </div>

      {/* Bottom Right Small Accent */}
      <div className="fixed bottom-20 right-10 z-0 opacity-30 pointer-events-none hidden lg:block">
        <svg
          width="150"
          height="150"
          viewBox="0 0 150 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 120C95 110 90 100 85 90"
            stroke="#C9B89A"
            strokeWidth="1"
            fill="none"
          />
          <path
            d="M85 90C80 95 75 100 70 105"
            stroke="#C9B89A"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </div>
    </>
  );
};

export default LeafDecoration;